import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../../utilities/classNames";
import DateTime from "../../../../../elements/DateTime";
import ClockIcon from "@dcl/icons/esm/ui/clock";
import LockIcon from "@dcl/icons/esm/ui/lock";

var ArticleCardFooter = function ArticleCardFooter(_ref) {
  var attributionName = _ref.attributionName,
      dateTime = _ref.dateTime,
      locked = _ref.locked,
      readingTime = _ref.readingTime;
  var getClassName = getClassNameFactory(ArticleCardFooter.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({})
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "dateAndAttribution"
    })
  }, /*#__PURE__*/React.createElement(DateTime, {
    dateTime: dateTime,
    lang: "en"
  }), attributionName ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "dotSeparator"
    })
  }, "\u2022"), attributionName) : null), readingTime ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "readingTime"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "readingTimeIcon"
    })
  }, /*#__PURE__*/React.createElement(ClockIcon, {
    width: 18
  })), readingTime) : null, locked ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "lockIcon"
    })
  }, /*#__PURE__*/React.createElement(LockIcon, {
    width: 18
  })) : null);
};

ArticleCardFooter.displayName = "ArticleCardFooter";
/* eslint-disable max-len */

ArticleCardFooter.propTypes = {
  /**
   * Name of the article attribution.
   */
  attributionName: PropTypes.string,

  /**
   * An ISO 8601, RFC 2822 or `new Date(str)` compatible date string.
   */
  dateTime: PropTypes.string.isRequired,

  /**
   * Optionally display a locked content indicator
   */
  locked: PropTypes.bool,

  /**
   * Reading time for the article. Use SI and common non-SI format (English: s = seconds, min = minutes, h = hours, d = days, i.e. "15 min" or "1 h". See https://en.wikipedia.org/wiki/International_System_of_Units#Units_and_prefixes.)
   */
  readingTime: PropTypes.string
};
/* eslint-enable max-len */

ArticleCardFooter.defaultProps = {};
export default ArticleCardFooter;